/**
 * Scroll utilities for AI Prescription
 */

import React from 'react';

/**
 * Scrolls container to show latest conversation from its beginning with smooth animation
 */
export const scrollToLatest = (
  resultsContainerRef: React.RefObject<HTMLDivElement>,
  latestConversationRef: React.RefObject<HTMLDivElement | null>,
  scrollTimeoutRef: React.MutableRefObject<NodeJS.Timeout | null>
) => {
  requestAnimationFrame(() => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = setTimeout(() => {
      if (resultsContainerRef.current && latestConversationRef.current) {
        const container = resultsContainerRef.current;
        const latestElement = latestConversationRef.current;

        const containerRect = container.getBoundingClientRect();
        const elementRect = latestElement.getBoundingClientRect();
        const relativeTop = elementRect.top - containerRect.top + container.scrollTop;

        container.scrollTo({
          top: relativeTop,
          behavior: "smooth",
        });
      } else if (resultsContainerRef.current) {
        const container = resultsContainerRef.current;
        container.scrollTo({
          top: container.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 100);
  });
};

/**
 * Keeps the bottom of the latest conversation (e.g. growing status checklist)
 * visible inside the results scroller as live updates append.
 */
export const scrollLatestBottomIntoView = (
  resultsContainerRef: React.RefObject<HTMLDivElement>,
  latestConversationRef: React.RefObject<HTMLDivElement | null>,
  scrollTimeoutRef: React.MutableRefObject<NodeJS.Timeout | null>
) => {
  requestAnimationFrame(() => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = setTimeout(() => {
      const container = resultsContainerRef.current;
      const latestElement = latestConversationRef.current;
      if (!container || !latestElement) return;

      const containerRect = container.getBoundingClientRect();
      const elementRect = latestElement.getBoundingClientRect();
      const relativeBottom =
        elementRect.bottom - containerRect.top + container.scrollTop;
      const padding = 24;

      container.scrollTo({
        top: Math.max(0, relativeBottom - container.clientHeight + padding),
        behavior: "smooth",
      });
    }, 50);
  });
};

